import React from 'react';
import Card from '../common/Card';
import { fmtUSDT, fmtNum } from '../../utils/format';

const StatsOverview = ({ user }) => {
  const u = user || {};
  const income = u.income || {};
  return (
    <div className="stat-row">
      <Card title="User ID" value={u.userId ? `#${u.userId}` : '—'} accent="yellow" />
      <Card
        title="Total Received"
        value={`${fmtUSDT(income.totalReceivedNet || 0)}`}
        sub="USDT (net)"
        accent="green"
      />
      <Card
        title="Total Income"
        value={`${fmtUSDT(income.totalIncomeGross || 0)}`}
        sub="USDT (gross)"
        accent="yellow"
      />
      <Card title="Direct Team" value={fmtNum(u.core?.directReferrals || 0)} sub="referrals" />
    </div>
  );
};

export default StatsOverview;
